/* ══════════════════════════════════════════════════════════════════════
   ELIAN — Commerce Engine
   ══════════════════════════════════════════════════════════════════════ */

'use strict';

// ── Page Loader ──────────────────────────────────────────────────────────────
(function () {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const loader = document.getElementById('page-loader');
      if (loader) loader.classList.add('hidden');
    }, 150);
  });
})();


// ── Momentum Rail ─────────────────────────────────────────────────────────────
window.initMomentumRail = function(selector) {
  document.querySelectorAll(selector).forEach(rail => {
    let isDown = false, startX, scrollLeft, velocity = 0, lastX = 0, rafId, lastTime = 0;

    function cancelMomentum() { cancelAnimationFrame(rafId); velocity = 0; }

    function decelerate() {
      if (Math.abs(velocity) < 0.3) { velocity = 0; return; }
      rail.scrollLeft -= velocity;
      velocity *= 0.92;
      rafId = requestAnimationFrame(decelerate);
    }

    rail.addEventListener('mousedown', e => {
      cancelMomentum();
      isDown = true;
      rail.classList.add('is-dragging');
      startX = e.pageX - rail.offsetLeft;
      scrollLeft = rail.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      e.preventDefault();
    });

    rail.addEventListener('mousemove', e => {
      if (!isDown) return;
      const x = e.pageX - rail.offsetLeft;
      const now = Date.now();
      const dt = now - lastTime || 1;
      velocity = (lastX - e.pageX) / dt * 16; // normalize to ~60fps
      lastX = e.pageX;
      lastTime = now;
      rail.scrollLeft = scrollLeft - (x - startX);
    });

    ['mouseleave', 'mouseup'].forEach(ev => {
      rail.addEventListener(ev, () => {
        if (!isDown) return;
        isDown = false;
        rail.classList.remove('is-dragging');
        rafId = requestAnimationFrame(decelerate);
      });
    });

    // Touch support
    let touchStartX, touchScrollLeft;
    rail.addEventListener('touchstart', e => {
      cancelMomentum();
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = rail.scrollLeft;
      lastX = touchStartX;
      velocity = 0;
    }, { passive: true });

    rail.addEventListener('touchmove', e => {
      const x = e.touches[0].pageX;
      velocity = (lastX - x) / 16;
      lastX = x;
      rail.scrollLeft = touchScrollLeft - (x - touchStartX);
    }, { passive: true });

    rail.addEventListener('touchend', () => {
      rafId = requestAnimationFrame(decelerate);
    });
  });
};

// ── Custom Cursor ─────────────────────────────────────────────────────────────
(function () {
  if (window.matchMedia('(hover: none)').matches) return; // skip touch devices
  const dot  = document.getElementById('cursor-dot');
  const ring = document.getElementById('cursor-ring');
  const label = document.getElementById('cursor-label');
  if (!dot || !ring) return;

  let mx = -100, my = -100, rx = -100, ry = -100;
  let currentState = 'default';
  const lerp = (a, b, n) => a + (b - a) * n;
  let rafRunning = false;

  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    dot.style.left  = mx + 'px';
    dot.style.top   = my + 'px';
    if (label) { label.style.left = (mx + 16) + 'px'; label.style.top = (my + 16) + 'px'; }
    if (!rafRunning) { rafRunning = true; raf(); }
  });
  document.addEventListener('mouseout', () => { dot.style.opacity='0'; ring.style.opacity='0'; });
  document.addEventListener('mouseover', () => { dot.style.opacity='1'; ring.style.opacity='1'; });

  function raf() {
    const dx = mx - rx, dy = my - ry;
    if (Math.abs(dx) < 0.1 && Math.abs(dy) < 0.1) { rafRunning = false; return; }
    rx = lerp(rx, mx, 0.12);
    ry = lerp(ry, my, 0.12);
    ring.style.left = rx + 'px';
    ring.style.top  = ry + 'px';
    requestAnimationFrame(raf);
  }

  function setState(state) {
    if (state === currentState) return;
    currentState = state;
    ring.dataset.state = state;
    if (label) label.textContent = state === 'default' ? '' : state.toUpperCase();
  }

  document.addEventListener('mouseover', e => {
    const el = e.target;
    if (el.closest('.momentum-rail, .sport-rail__track, [data-drag]')) setState('drag');
    else if (el.closest('.product-card')) setState('view');
    else if (el.closest('a, button, [role="button"]')) setState('link');
    else setState('default');
  });
})();

// ── Scroll Progress ───────────────────────────────────────────────────────────
(function () {
  const bar = document.getElementById('scroll-progress');
  if (!bar) return;
  window.addEventListener('scroll', () => {
    const h = document.documentElement;
    const pct = (h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100;
    bar.style.width = pct + '%';
  }, { passive: true });
})();

// ── Nav Scroll Behaviour ──────────────────────────────────────────────────────
(function () {
  const nav = document.getElementById('nav');
  if (!nav) return;
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 80);
  }, { passive: true });
})();

// ── Reveal on Scroll ──────────────────────────────────────────────────────────
(function () {
  const els = document.querySelectorAll('.reveal, .reveal-left');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const delay = parseFloat(entry.target.dataset.delay || 0) + i * 0.07;
        entry.target.style.transitionDelay = delay + 's';
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  els.forEach(el => obs.observe(el));
})();

// ── Toast ─────────────────────────────────────────────────────────────────────
window.showToast = function (msg, duration = 3500) {
  const toast = document.getElementById('elian-toast');
  const msgEl = document.getElementById('toast-msg');
  if (!toast || !msgEl) return;
  msgEl.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
};

// ── Search Overlay ─────────────────────────────────────────────────────────────
window.openSearch = function () {
  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  setTimeout(() => overlay.querySelector('input')?.focus(), 100);
  document.body.style.overflow = 'hidden';
};
window.closeSearch = function () {
  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.setAttribute('aria-hidden', 'true');
  overlay.classList.remove('open');
  document.body.style.overflow = '';
};
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeSearch(); closeCartDrawer(); closeEmailPopup(); }
  if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
});

// ── Cart Drawer ───────────────────────────────────────────────────────────────
(function () {
  let overlay, drawer;

  function buildDOM() {
    if (document.getElementById('cart-drawer')) return;
    overlay = document.createElement('div');
    overlay.id = 'cart-overlay';
    overlay.addEventListener('click', window.closeCartDrawer);

    drawer = document.createElement('div');
    drawer.id = 'cart-drawer';
    drawer.innerHTML = `
      <div class="cart-header">
        <h3>Winkelwagen</h3>
        <button class="cart-close" onclick="closeCartDrawer()" aria-label="Sluiten">&times;</button>
      </div>
      <div class="cart-body" id="cart-body"></div>
      <div class="cart-shipping-bar" id="cart-shipping-bar" style="display:none">
        <p class="shipping-bar-text" id="shipping-bar-text"></p>
        <div class="cart-shipping-bar"><div class="shipping-bar-track"><div class="shipping-bar-fill" id="shipping-bar-fill" style="width:0%"></div></div></div>
      </div>
      <div class="cart-footer" id="cart-footer" style="display:none">
        <div class="cart-subtotal">
          <span>Subtotaal</span>
          <span id="cart-total-price"></span>
        </div>
        <a href="/checkout" class="cart-checkout">Afrekenen &rarr;</a>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }

  window.openCartDrawer = function () {
    buildDOM();
    document.getElementById('cart-overlay').classList.add('open');
    document.getElementById('cart-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCartDrawer = function () {
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  };

  window.renderCartDrawer = function (cart) {
    buildDOM();
    const body   = document.getElementById('cart-body');
    const footer = document.getElementById('cart-footer');
    const shipBar= document.getElementById('cart-shipping-bar');
    const shipTxt= document.getElementById('shipping-bar-text');
    const fill   = document.getElementById('shipping-bar-fill');
    const total  = document.getElementById('cart-total-price');

    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `<div class="cart-empty">
        <div class="cart-empty-icon">&#128722;</div>
        <p>Je winkelwagen is leeg.</p>
        <a href="/collections/all" class="btn-outline" onclick="closeCartDrawer()">Ontdek collectie</a>
      </div>`;
      if (footer) footer.style.display = 'none';
      if (shipBar) shipBar.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.title}" class="cart-item-img" loading="lazy">
        <div class="cart-item-info">
          <div class="cart-item-title">${item.product_title}</div>
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item-qty">
            <button class="cart-qty-btn" onclick="updateCartItem(${item.variant_id}, ${item.quantity - 1})">&#8722;</button>
            <span class="cart-qty-val">${item.quantity}</span>
            <button class="cart-qty-btn" onclick="updateCartItem(${item.variant_id}, ${item.quantity + 1})">&#43;</button>
          </div>
        </div>
        <button class="cart-item-remove" onclick="updateCartItem(${item.variant_id}, 0)" aria-label="Verwijderen">&#x2715;</button>
      </div>
    `).join('');

    // Shipping progress (free at €30 = 3000 cents)
    const FREE_THRESHOLD = 3000;
    const pct = Math.min(100, (cart.total_price / FREE_THRESHOLD) * 100);
    if (cart.total_price >= FREE_THRESHOLD) {
      if (shipTxt) shipTxt.innerHTML = '&#10003; <strong>Gratis verzending</strong> inbegrepen!';
    } else {
      const left = formatMoney(FREE_THRESHOLD - cart.total_price);
      if (shipTxt) shipTxt.innerHTML = `Nog ${left} voor <strong>gratis verzending</strong>`;
    }
    if (fill) fill.style.width = pct + '%';
    if (shipBar) shipBar.style.display = 'block';

    if (total) total.textContent = formatMoney(cart.total_price);
    if (footer) footer.style.display = 'block';

    // Update cart badge
    const badge = document.querySelector('.cart-count-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('has-items', cart.item_count > 0);
    }
  };

  window.updateCartItem = async function (variantId, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    const cart = await res.json();
    renderCartDrawer(cart);
  };

  window.formatMoney = function (cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  };
})();


// ── Wishlist (localStorage-based) ──────────────────────────────────────────
window.toggleWishlist = function(productId, title) {
  const key = 'elian_wishlist';
  const list = JSON.parse(localStorage.getItem(key) || '[]');
  const idx  = list.indexOf(productId);
  if (idx === -1) {
    list.push(productId);
    showToast('\u2665 ' + (title || 'Product') + ' opgeslagen');
  } else {
    list.splice(idx, 1);
    showToast('Verwijderd uit verlanglijst');
  }
  localStorage.setItem(key, JSON.stringify(list));
  // Update heart state
  document.querySelectorAll('[data-wishlist="' + productId + '"]').forEach(btn => {
    btn.classList.toggle('active', idx === -1);
    btn.setAttribute('aria-pressed', idx === -1);
  });
};

// ── Quick Add ─────────────────────────────────────────────────────────────────
window.quickAdd = async function (variantId, title) {
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    const cart = await fetch('/cart.js').then(r => r.json());
    renderCartDrawer(cart);
    openCartDrawer();
    showToast('\u2713 ' + title + ' toegevoegd');
  } catch (_) {
    showToast('Kon niet toevoegen. Probeer opnieuw.');
  }
};

// ── Quick View ─────────────────────────────────────────────────────────────────
window.openQuickView = async function (handle) {
  let modal = document.getElementById('quick-view-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'quick-view-modal';
    modal.style.cssText = `
      position:fixed;inset:0;z-index:900;display:flex;align-items:center;justify-content:center;
      background:rgba(0,0,0,.85);backdrop-filter:blur(10px);padding:20px;
      opacity:0;pointer-events:none;transition:opacity .35s;
    `;
    modal.innerHTML = '<div id="qv-inner" style="background:var(--surface);max-width:860px;width:100%;max-height:90vh;overflow:auto;position:relative;"></div>';
    modal.addEventListener('click', e => { if (e.target === modal) closeQuickView(); });
    document.body.appendChild(modal);
  }

  const inner = document.getElementById('qv-inner');
  inner.innerHTML = '<div style="padding:60px;text-align:center;color:var(--ink-3)">Laden...</div>';
  modal.style.opacity = '1';
  modal.style.pointerEvents = 'all';

  try {
    const p = await fetch(`/products/${handle}.js`).then(r => r.json());
    const v = p.variants?.[0] || {};
    const compareHtml = p.compare_at_price > p.price
      ? `<span style="color:var(--ink-3);text-decoration:line-through;font-size:1rem">${formatMoney(p.compare_at_price)}</span>`
      : '';

    inner.innerHTML = `
      <button onclick="closeQuickView()" style="position:absolute;top:14px;right:16px;background:none;border:1px solid var(--border-2);color:var(--ink-2);width:36px;height:36px;cursor:none;font-size:1rem;display:flex;align-items:center;justify-content:center;" aria-label="Sluiten">&times;</button>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:0">
        <img src="${p.images?.[0]}" alt="${p.title}" style="width:100%;aspect-ratio:1;object-fit:cover;" loading="lazy">
        <div style="padding:36px 32px">
          <p style="font-size:.7rem;letter-spacing:.18em;text-transform:uppercase;color:var(--gold);margin-bottom:10px">${p.type || 'Product'}</p>
          <h2 style="font-family:var(--font-serif);font-size:1.8rem;font-weight:400;margin-bottom:16px;line-height:1.2">${p.title}</h2>
          <div style="display:flex;align-items:baseline;gap:12px;margin-bottom:20px">
            <span style="font-size:1.5rem;font-weight:700">${formatMoney(p.price)}</span>
            ${compareHtml}
          </div>
          <div style="font-size:.875rem;color:var(--ink-2);line-height:1.7;margin-bottom:24px;max-height:120px;overflow:hidden">${p.description?.replace(/<[^>]*>/g,'').slice(0,250)}...</div>
          <button onclick="quickAdd(${v.id}, '${p.title.replace(/'/g,"\\'")}'); closeQuickView();"
            style="width:100%;padding:14px;background:var(--gold);border:none;color:var(--bg);font-size:.8rem;font-weight:800;letter-spacing:.14em;text-transform:uppercase;cursor:none;font-family:var(--font)">
            In winkelwagen
          </button>
          <a href="/products/${handle}" style="display:block;text-align:center;margin-top:12px;font-size:.78rem;color:var(--ink-3);letter-spacing:.08em">Bekijk volledig product &rarr;</a>
        </div>
      </div>
    `;
  } catch (_) {
    inner.innerHTML = '<div style="padding:40px;text-align:center;color:var(--ink-3)">Kon product niet laden.</div>';
  }
};
window.closeQuickView = function () {
  const m = document.getElementById('quick-view-modal');
  if (m) { m.style.opacity = '0'; m.style.pointerEvents = 'none'; }
};

// ── Wishlist ──────────────────────────────────────────────────────────────────
(function () {
  const KEY = 'axara_wishlist';
  const getList = () => JSON.parse(localStorage.getItem(KEY) || '[]');
  const save = l => localStorage.setItem(KEY, JSON.stringify(l));

  window.toggleWishlist = function (handle, btn) {
    let list = getList();
    const idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
      btn?.classList.add('wishlisted');
      showToast('\u2665 Toegevoegd aan verlanglijst');
    } else {
      list.splice(idx, 1);
      btn?.classList.remove('wishlisted');
      showToast('Verwijderd van verlanglijst');
    }
    save(list);
  };

  // Mark wishlisted items on page load
  document.addEventListener('DOMContentLoaded', () => {
    const list = getList();
    document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
      if (list.includes(btn.dataset.wishlistHandle)) btn.classList.add('wishlisted');
    });
  });
})();

// ── Social Proof ──────────────────────────────────────────────────────────────
(function () {
  const proofs = [
    { name: 'Emre K., Amsterdam', msg: 'heeft zojuist een product besteld' },
    { name: 'Sofia L., Rotterdam', msg: 'heeft toegevoegd aan winkelwagen' },
    { name: 'Lars V., Utrecht', msg: 'heeft zojuist een bestelling geplaatst' },
    { name: 'Noor B., Den Haag', msg: 'kijkt naar dit product' },
    { name: 'Sander M., Eindhoven', msg: 'heeft zojuist een product besteld' },
    { name: 'Iris P., Groningen', msg: 'heeft toegevoegd aan verlanglijst' },
    { name: 'Tim R., Breda', msg: 'heeft zojuist een bestelling geplaatst' },
    { name: 'Mila J., Haarlem', msg: 'heeft toegevoegd aan winkelwagen' },
  ];

  let el;

  function show() {
    const item = proofs[Math.floor(Math.random() * proofs.length)];
    if (!el) {
      el = document.createElement('div');
      el.style.cssText = `
        position:fixed;bottom:28px;left:24px;z-index:799;
        background:var(--surface-2);border:1px solid var(--border-2);border-left:2px solid var(--gold);
        padding:12px 16px;max-width:280px;
        transform:translateX(-120%);transition:transform .45s cubic-bezier(.34,1.56,.64,1);
        font-size:.78rem;
      `;
      document.body.appendChild(el);
    }

    el.innerHTML = `
      <div style="font-weight:600;color:var(--ink);margin-bottom:3px">${item.name}</div>
      <div style="color:var(--ink-3)">${item.msg} <span style="color:var(--gold)">&#9679;</span> zojuist</div>
    `;
    el.style.transform = 'translateX(0)';
    setTimeout(() => { if (el) el.style.transform = 'translateX(-120%)'; }, 4500);
  }

  setTimeout(() => {
    show();
    setInterval(show, 15000 + Math.random() * 8000);
  }, 12000);
})();

// ── Product Form AJAX ─────────────────────────────────────────────────────────
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('product-form');
    if (!form) return;

    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn     = document.getElementById('atc-btn');
      const txt     = document.getElementById('atc-text');
      const spinner = document.getElementById('atc-spinner');
      if (!btn) return;

      btn.disabled = true;
      if (txt)     txt.style.display    = 'none';
      if (spinner) spinner.style.display = 'flex';

      const fd  = new FormData(form);
      const vid = fd.get('id');
      const qty = parseInt(fd.get('quantity') || '1');

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: qty })
        });
        const cart = await fetch('/cart.js').then(r => r.json());

        if (spinner) spinner.style.display = 'none';
        if (txt)     { txt.textContent = '\u2713 Toegevoegd!'; txt.style.display = 'block'; }
        btn.style.background = 'linear-gradient(135deg, #059669, #10b981)';
        btn.style.color = '#fff';

        renderCartDrawer(cart);
        openCartDrawer();
        showToast('Product toegevoegd aan winkelwagen!');

        setTimeout(() => {
          btn.disabled = false;
          btn.style.background = '';
          btn.style.color = '';
          if (txt) txt.textContent = 'In winkelwagen';
        }, 2800);
      } catch (_) {
        btn.disabled = false;
        if (spinner) spinner.style.display = 'none';
        if (txt) txt.style.display = 'block';
        showToast('Er ging iets mis. Probeer het opnieuw.');
      }
    });
  });
})();

// ── Accordion ─────────────────────────────────────────────────────────────────
window.toggleAcc = function (btn) {
  const body = btn.nextElementSibling;
  const icon = btn.querySelector('.acc-icon');
  const isOpen = body.classList.contains('open');
  document.querySelectorAll('.acc-body.open').forEach(b => {
    b.classList.remove('open');
    const ic = b.previousElementSibling?.querySelector('.acc-icon');
    if (ic) ic.style.transform = 'rotate(0deg)';
  });
  if (!isOpen) {
    body.classList.add('open');
    if (icon) icon.style.transform = 'rotate(180deg)';
  }
};

// ── Gallery ───────────────────────────────────────────────────────────────────
window.switchImage = function (url, btn) {
  const img = document.getElementById('main-img');
  if (!img) return;
  img.style.opacity = '0';
  setTimeout(() => { img.src = url; img.style.opacity = '1'; }, 150);
  document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
};

// ── Image Zoom ────────────────────────────────────────────────────────────────
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const main = document.querySelector('.gallery-main');
    const img  = document.getElementById('main-img');
    if (!main || !img) return;
    main.addEventListener('mousemove', e => {
      const r = main.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
      const y = ((e.clientY - r.top)  / r.height * 100).toFixed(1);
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(1.6)';
    });
    main.addEventListener('mouseleave', () => {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center';
    });
  });
})();

// ── Quantity ─────────────────────────────────────────────────────────────────
window.changeQty = function (delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  input.value = Math.min(10, Math.max(1, parseInt(input.value || '1') + delta));
};

// ── Sticky ATC ────────────────────────────────────────────────────────────────
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const atc  = document.getElementById('atc-btn');
    const bar  = document.getElementById('sticky-atc');
    if (!atc || !bar) return;
    const obs = new IntersectionObserver(entries => {
      bar.classList.toggle('visible', !entries[0].isIntersecting);
      bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(atc);
  });
})();

// ── Countdown Timer ───────────────────────────────────────────────────────────
(function () {
  const el = document.getElementById('countdown-timer');
  if (!el) return;
  const KEY = 'axara_cd_end';
  let end = parseInt(localStorage.getItem(KEY) || '0');
  if (!end || end < Date.now()) {
    end = Date.now() + (5 + Math.floor(Math.random() * 4)) * 3600000;
    localStorage.setItem(KEY, end.toString());
  }
  setInterval(() => {
    const diff = Math.max(0, end - Date.now());
    const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    el.textContent = `${h}:${m}:${s}`;
  }, 1000);
})();

// ── Magnetic Buttons ──────────────────────────────────────────────────────────
(function () {
  if (window.matchMedia('(hover: none)').matches) return;
  document.addEventListener('mousemove', e => {
    document.querySelectorAll('.btn--magnetic').forEach(btn => {
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const range = 80;
      if (dist < range) {
        const pull = (1 - dist / range) * 0.25;
        btn.style.transform = `translate(${dx * pull}px, ${dy * pull}px)`;
      } else {
        btn.style.transform = '';
      }
    });
  });
})();

// Product image physics (subtle pointer parallax)
(function () {
  if (window.matchMedia('(hover: none)').matches) return;
  document.addEventListener('mousemove', e => {
    document.querySelectorAll('.product-card:hover .product-card__img').forEach(img => {
      const rect = img.closest('.product-card').getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = (e.clientX - cx) / rect.width;
      const dy = (e.clientY - cy) / rect.height;
      img.style.transform = `scale(1.04) translate(${dx * 4}px, ${dy * 3}px)`;
    });
  });
})();

// ── Email Popup ───────────────────────────────────────────────────────────────
(function () {
  const KEY = 'axara_popup_ts';
  const canShow = () => {
    const ts = localStorage.getItem(KEY);
    return !ts || Date.now() - parseInt(ts) > 7 * 86400000;
  };
  const getPopup = () => document.getElementById('email-popup');

  function show() {
    const popup = getPopup();
    if (!popup || !canShow() || popup.classList.contains('shown')) return;
    popup.classList.add('visible', 'shown');
    popup.setAttribute('aria-hidden', 'false');
  }

  window.closeEmailPopup = function () {
    const popup = getPopup();
    if (!popup) return;
    popup.classList.remove('visible');
    localStorage.setItem(KEY, Date.now().toString());
  };

  window.submitEmailPopup = function (e) {
    e.preventDefault();
    const email = document.getElementById('popup-email-input')?.value || '';
    window.closeEmailPopup();
    try {
      const leads = JSON.parse(localStorage.getItem('axara_leads') || '[]');
      leads.push({ email, ts: new Date().toISOString(), source: 'popup' });
      localStorage.setItem('axara_leads', JSON.stringify(leads));
    } catch (_) {}
    showToast('Kortingscode WELKOM10 verstuurd \uD83C\uDF89');
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!canShow()) return;
    setTimeout(show, 10000);
    document.addEventListener('mouseleave', function handler(e) {
      if (e.clientY < 20) { show(); document.removeEventListener('mouseleave', handler); }
    });
  });
})();

// ── Sort collection ───────────────────────────────────────────────────────────
window.sortCollection = function (val) {
  if (!val) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', val);
  window.location.href = url.toString();
};

// ── Inline email submit ───────────────────────────────────────────────────────
window.inlineEmailSubmit = function (e) {
  e.preventDefault();
  const email = e.target.querySelector('[type="email"]')?.value || '';
  if (!email) return;
  try {
    const leads = JSON.parse(localStorage.getItem('axara_leads') || '[]');
    leads.push({ email, ts: new Date().toISOString(), source: 'inline' });
    localStorage.setItem('axara_leads', JSON.stringify(leads));
  } catch (_) {}
  showToast('Code WELKOM10 is onderweg! \uD83C\uDF89');
  e.target.reset();
};


// Init all momentum rails on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  initMomentumRail('.momentum-rail');
});
